import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { MainJobRoutingModule } from './main-job-routing.module';

// OTHER MODULE IMPORTS

import { SharedModule } from './../../shared.module';
import { MaterialsModule } from './../../materials.module';
import { MainAttendanceModule } from './../../attendance/main-attendance/main-attendance.module';
import { MainClientModule } from '../../clients/main-client/main-client.module';
import { MainCourseModule } from '../../courses/main-course/main-course.module';
import { MainDocumentModule } from '../../documents/main-document/main-document.module';
import { MainLearnerModule } from '../../learners/main-learner/main-learner.module';
import { MainMedicalModule } from '../../medical/main-medical/main-medical.module';
import { MainPortfolioModule } from '../../portfolio/main-portfolio/main-portfolio.module';
import { MainSchedulerModule } from '../../scheduler/main-scheduler/main-scheduler.module';


// IMPORT JOB MODULE COMPONENTS

import { JobsComponent } from './../jobs.component';
import { MainJobComponent } from './main-job.component';
import { JobComponent } from './../job/job.component';
import { AddJobModalComponent } from './../add-job-modal/add-job-modal.component';
import { EditJobModalComponent } from './../edit-job-modal/edit-job-modal.component';
import { CardViewComponent } from './../card-view/card-view.component';
import { AddMpJobComponent } from './../add-mp-job/add-mp-job.component';
import { EditMpJobComponent } from './../edit-mp-job/edit-mp-job.component';
import { AllocateLearnerModalComponent } from './../job/allocate-learner-modal/allocate-learner-modal.component';
import { JobDatesComponent } from './../job-dates/job-dates.component';
import { MpjobComponent } from './../mpjob/mpjob.component';
import { TrainingJobDatesComponent } from '../training-job-dates/training-job-dates.component';

@NgModule({
  declarations: [
    MainJobComponent,
    JobComponent,
    JobsComponent,
    AddJobModalComponent,
    EditJobModalComponent,
    CardViewComponent,
    AddMpJobComponent,
    EditMpJobComponent,
    AllocateLearnerModalComponent,
    JobDatesComponent,
    MpjobComponent,
    TrainingJobDatesComponent
  ],
  imports: [
    CommonModule,
    MainJobRoutingModule,
    SharedModule,
    MaterialsModule,
    MainAttendanceModule,
    // MainClientModule,
    MainCourseModule,
    MainDocumentModule,
    MainLearnerModule,
    MainMedicalModule,
    MainPortfolioModule,
    MainSchedulerModule
  ],
  entryComponents: [
    AllocateLearnerModalComponent,
    // JobComponent
  ],
  exports: [
    MainJobComponent,
    JobComponent,
    JobsComponent,
    MpjobComponent,
    AddJobModalComponent,
    JobDatesComponent
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class MainJobModule { }
